import { CommonFunctions } from '../static/common-functions';
//import { Console } from '@angular/core/src/console';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';

export class DispatchBus extends BaseBus
{
  CID(): any {
    return this.dispatchId;
    }
    get CUpdateDate(): Date {
        return this.updateDt;
    }
  constructor(data: DispatchBus) {
    super(data);
    //Object.assign(this, data);
    //try {
    //  this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
    //  this.insertDt = CommonFunctions.getDate(data.insertDt);
    //  this.updateDt = CommonFunctions.getDate(data.updateDt);
    //  this.estimatedBeginDate = CommonFunctions.getDate(data.estimatedBeginDate);
    //  this.estimatedEndDate = CommonFunctions.getDate(data.estimatedEndDate);

    //  this.jobWarrantyEndDate = CommonFunctions.getDate(data.jobWarrantyEndDate);
    //  this.refTrackNbrDt = CommonFunctions.getDate(data.refTrackNbrDt);
    //  this.finalBillingDt = CommonFunctions.getDate(data.finalBillingDt);
    //  this.sageDt = CommonFunctions.getDate(data.sageDt);
    //}
    //catch {

    //}
  }
  initialize(data: DispatchBus) {
    super.initialize(data);
    try {
      this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.slaDate = CommonFunctions.getDate(data.slaDate);
        this.slaTime = CommonFunctions.getDate(data.slaTime);
        //this.updateDt = CommonFunctions.getDate(data.updateDt);
      this.estimatedBeginDate = CommonFunctions.getDate(data.estimatedBeginDate);
      this.estimatedEndDate = CommonFunctions.getDate(data.estimatedEndDate);

      this.jobWarrantyEndDate = CommonFunctions.getDate(data.jobWarrantyEndDate);
      this.refTrackNbrDt = CommonFunctions.getDate(data.refTrackNbrDt);
      this.finalBillingDt = CommonFunctions.getDate(data.finalBillingDt);
      this.sageDt = CommonFunctions.getDate(data.sageDt);
        this.refreshDate = CommonFunctions.getDate(data.refreshDate);
        this.isCallback = CommonFunctions.getNumberValue(data.isCallback);
    }
    catch {

    }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.receivedDateTime = DateFunctions.getDateNow();
        this.receivedById = personId;
        this.dispatchStatusId = CommonValues.Dispatch_ReadyForDispatch;
        this.priorityId = null;
    }
  setFromForm(data: DispatchBus) {
    super.setFromForm(data);
      let dateNow = CommonFunctions.getDateNow();

    if (this.hasId) {
      //this.updateDt = dateNow;
      //this.insertDt = data.insertDt;
      //this.insertUserId = data.insertUserId;
    }
    else {
      this.insertDt = dateNow;
      this.insertUserId = data.insertUserId;
    }
    
    }
    setBeforeSave() {
        this.receivedDateTime = DateFunctions.getDateTimeWithUTCOffset(this.receivedDateTime);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.slaDate = DateFunctions.getDateTimeWithUTCOffset(this.slaDate);
        this.slaTime = DateFunctions.getDateTimeWithUTCOffset(this.slaTime);

        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            //this.updateDt = date;
            this.updateUserid = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.companyId = companyId;
            //this.updateDt = date;
            this.updateUserid = userId;
        }
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }

  dispatchId: any;
  customerId: any;
  locationId: any;
  companyId: any;
  priorityId: any;
  dispatchStatusId: any;
  receivedById: any;
  quoteId: any;
  invoiceId: any;
  receivedDateTime: Date;
  needsQuote: boolean;
  notToExceed: number;
  dispatchNumber: string;
  ponumber: string;
  whoCalledName: string;
  dispatchReason: string;
  insertUserId: any;
  insertDt: Date;
  updateUserid: any;
  updateDt: Date;
  wonumber: string;
  accountClassId: any;
  accountClassSubClassId: any;
  purchaserPersonId: any;
  callbackId: any;
  isProgressBill: boolean;
  estimatedBeginDate: Date;
  estimatedEndDate: Date;
  isConstruction: boolean;
  contractPrice: number;
  pooverrideUserId: any;
  estimatedCost: number;
  relatedJobTypeId: any;
  jobWarrantyEndDate: Date;
  masterJobId: any;
  foremanId: any;
  refTrackNbr: string;
  refTrackNbrDt: Date;
  refTrackNbrUserId: any;
  minimumSkill: number;
  pmprice: number;
  labTaxRate: number;
  matTaxRate: number;
  otherTaxRate: number;
  isRetailTax: boolean;
  stockReplenishWh: any;
  finalBillingDt: Date;
  jobClassificationId: any;
  contractAdminId: any;
  contractProjAdminId: any;
  wipcomplete: boolean;
  contractProjEstId: any;
  certPayrollRequired: boolean;
  drawDateInfo: string;
  changeOrderInfo: string;
  sageDt: Date;
  autoCreateId: string;
  dispatchRepairCatId: any;
  contractDivisionId: any;
  contractJrProjAdminId: any;
  dispatchActionCodesId: any;
  dispatchSummaryCodeId: any;
  dispatchCauseCodesId: any;
  dispatchFailureCodesId: any;
  dispatchProblemCodeId: any;
  refreshDate: Date;
  completeResources: boolean;
  callbackRFBNote: string;
  timeMat: Boolean;
  timeMatPercent: number;
  slaDate: Date;
  slaTime: Date;
  callbackSystemIdNote: string;
  isCallback: number;
  rankOrderId:string;
  prioritySubTypeId: any;
}
